export default __webpack_public_path__ + "static/media/vortex.3ed62dea.webp";